import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { Route } from '../../../../domain/route/Route';
import { Text } from '../../../../react-components/Text';

import { useState } from 'react';
import iconNorthStar from '../../../../assets/img/shared/icon-northStar.svg';

import { useNavigate } from 'react-router-dom';
import { PlusIcon } from '../../../../assets/svg/PlusIcon';
import { DraggableContainer } from '../../../../components/DraggableContainer';
import { LoadingButton } from '../../../../components/LoadingButton';
import * as routing from '../../../../constants/Routing';
import { intl } from '../../../../helpers/IntGlobalProvider';
import { usePermissions } from '../../hooks/usePermissions';
import { RouteCreation } from '../../routes-list/route-creation/RouteCreation';
import { RouteDragIcon } from '../stops/RouteDragIcon';
import { RouteSurvey } from '../stops/route-survey/RouteSurvey';
import { RouteCompletedStats } from './RouteCompletedStats';

interface RouteCompletedDialogProps {
  selectedRoute: Route;
  open: boolean;
  onClose: () => void;
}

export const RouteCompletedDialog = ({ selectedRoute, open, onClose }: RouteCompletedDialogProps) => {
  const { canCreateRoutes, canCreateSurvey } = usePermissions();
  const [isRouteCreationOpen, setIsRouteCreationOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const showSurvey = selectedRoute.status === `finished` && canCreateSurvey;

  if (!open) return null;

  return (
    <>
      <DraggableContainer
        sizeOfFooter={154}
        sizeOfTopButtons={0}
        respectFooter={true}
        halfWindowHeightLoss={0.2}
        // initScroll={topScroll}
        drags={[
          <Grid container direction="column" alignItems="center" style={{ userSelect: `none` }}>
            <RouteDragIcon />
            <VSpacer small />
            <Grid container wrap="nowrap" direction="column" alignItems="center">
              <Text
                variant="h5"
                intlId="driver.stops.congratulations.title"
                style={{ color: RoutalPalette.secondary40, textAlign: `center` }}
              />
              <VSpacer small />
              <Text
                intlId="driver.stops.congratulations.subtitle"
                style={{ color: RoutalPalette.secondary40, textAlign: `center` }}
              />
            </Grid>
            <VSpacer medium />
          </Grid>,
        ]}
        details={[
          <Grid style={{ overflowY: `hidden`, padding: `0 40px` }}>
            <Grid container direction="column" alignItems="center">
              <RouteCompletedStats selectedRoute={selectedRoute} />
            </Grid>

            {showSurvey && (
              <>
                <VSpacer large />
                <RouteSurvey route={selectedRoute} />
              </>
            )}
          </Grid>,
        ]}
      />
      {!isRouteCreationOpen && (
        <Grid
          style={{
            position: `absolute`,
            bottom: 0,
            left: 0,
            width: `100%`,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`,
            height: canCreateRoutes ? `154px` : `92px`,
            zIndex: 1005,
            backgroundColor: RoutalPalette.white,
            padding: `20px`,
            borderTop: `1px solid ${RoutalPalette.neutral10}`,
            flexDirection: `column`,
          }}
        >
          {canCreateRoutes ? (
            <>
              <LoadingButton
                onClick={() => {
                  setIsRouteCreationOpen(true);
                }}
                style={{ boxSizing: `border-box`, height: `52px`, width: `100%`, borderRadius: `10px`, margin: `0px` }}
                variant="flat"
              >
                <PlusIcon color={RoutalPalette.primary40} />
                <HSpacer small />
                {intl.formatMessage({ id: `drivers.route.create_new` })}
              </LoadingButton>
              <VSpacer small />
            </>
          ) : null}

          <LoadingButton
            onClick={() => {
              onClose();
              navigate(routing.ROOT);
            }}
            style={{ boxSizing: `border-box`, height: `52px`, width: `100%`, borderRadius: `10px`, margin: `0px` }}
          >
            <img
              src={iconNorthStar}
              alt="Customer fields"
              style={{ height: `15px`, width: `15px`, paddingRight: `8px` }}
            />
            <HSpacer small />
            {intl.formatMessage({ id: `driver.stops.congratulations.go_to_home` })}
          </LoadingButton>
        </Grid>
      )}
      <RouteCreation
        isOpen={isRouteCreationOpen}
        onClose={() => {
          setIsRouteCreationOpen(false);
        }}
        beforeLeave={() => {
          onClose();
        }}
      />
    </>
  );
};
